module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff
// module id = 472
// module chunks = 2